module.exports = __webpack_public_path__ + "static/media/perspective-taking-large@3x.3b0f79bb.png";